import React, {useEffect} from 'react'
import Modal from 'react-bootstrap/Modal'
import ClassEditor from 'components/Store/ClassEditor'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown'
import {useDispatch, useSelector} from 'react-redux'
import { useForm, Controller } from "react-hook-form";
import { DevTool } from "react-hook-form-devtools";
import * as yup from 'yup';
import FormGroup from 'components/Form/FormGroup'
import Button from 'react-bootstrap/Button'
import moment from 'moment-timezone'
// import { saveOffering } from 'store/actions/offeringsActions'
import { deleteCoupon, saveCoupon } from 'store/actions/couponActions'
import SweetAlert from 'react-bootstrap-sweetalert'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit';
import { deleteOffering } from 'store/actions/offeringsActions'
import analytics from 'util/analytics';
import Spinner from 'react-bootstrap/Spinner'
import FormImageUploader from 'components/Form/FormImageUploader'
import {symbolFromCurrency} from 'components/PartnerInfoForm'
import {useLocation} from 'util/router'
import FormDatePicker from 'components/Form/FormDatePicker'
const DATE_FORMAT = 'ddd MMM D, YYYY';

const locationTypeOptions = [
    {
        label: "In-Person Classes",
        value: "inperson"
    },
    {
        label: "Livestream Classes",
        value: "live"
    },
    {
        label: "On Demand Videos",
        value: "ondemand"
    },
    {
        label: "Private Sessions",
        value: "private"
    }
]

const offeringTypeOptions = [
    {
        label: "Subscription",
        value: "subscription"
    },
    {
        label: "Class Package",
        value: "pack"
    }
]

const newStudentOnlyOptions = [
    {
        label: "New students only",
        value: true
    },
    {
        label: "New & existing students",
        value: false
    }
]

const redemptionTypeOptions = [
    {
        label: "Each student can use this once",
        value: "once_per_customer"
    },
    {
        label: "Limit the amount of uses per student",
        value: "limited_per_customer"
    },
    {
        label: "Limit the amount of total uses",
        value: "limited"
    },
    {
        label: "Unlimited usage",
        value: "unlimited"
    }
]

const discountTypeOptions = [
    {
        label: "Percentage",
        value: "percentage"
    },
    {
        label: "Amount",
        value: "amount"
    }
]

function CouponEditor(props) {

    const offerings = useSelector(state => state.instructor.offerings.filter(val => !val.deleted))
    const offeringOptions = offerings.map(val => {
        return {
            label: val.name,
            value: val.id
        }
    })

    var instructor_classes = useSelector(state => state.instructor.classes.filter(val => {
        return ["live", "inperson", "private"].includes(val.location_type)
    }));

    const NOW = moment().unix()

    const sorted_upcoming_classes = instructor_classes.filter(val => {
        return (val.start_time) > NOW;
    // return (val.start_time) > moment().unix();
    }).sort(function (a, b) {
        if (a.start_time && b.start_time) {
            return a.start_time - b.start_time;
        }
        return 0;
    })

    const sorted_previous_classes = instructor_classes.filter(val => {
        return val.start_time < NOW;
    }).sort(function (a, b) {
        if (a.start_time && b.start_time) {
            return b.start_time - a.start_time;
        }
        return 0;
    })

    const classOptions = sorted_upcoming_classes.concat(sorted_previous_classes).map(val => {
        return {
            label: val.name + " | " + moment(val.start_time * 1000).format("llll"),
            value: val.id
        }
    })

    const dispatch = useDispatch()
    const partnerId = useSelector(state => state.instructor.instructor.platformID)
    const currency = useSelector(state => state.instructor.instructor.instructorProfile?.currency ?? "USD");
    const currencySymbol = symbolFromCurrency(currency)
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    });

    const { toEdit } = props
    // var {pack, subscription, challenge, oneTimeOffer} = props
    var offeringType = null

    var defaultDescription = ""
    var defaultDescriptionHTML = ""

    var viewModel = {
        placeholders: {
            name: "",
            price: "",
            description: ""
        }
    }

    // const defualtToEdit = {...toEdit}
    const { register, control, handleSubmit, setValue, formState, errors, dirty, getValues, watch } = useForm({
        mode: 'onBlur',
        validationSchema: yup.object({
            code: yup.string().required('Please enter a promo code').trim('Must not contain any spaces'),

            discount_type: yup.string().required('Please pick a discount type'),
            discount_amount: yup.number("Please enter a valid price greater than zero").positive("Please enter a positive number").required('Please enter a price').typeError('Please enter a valid price greater than zero'),

            redemption_type: yup.string().required('Please choose how this can be redeemed'),
            max_redemptions: yup.number(),
            max_redemptions_user: yup.number(),

            applies_to_all: yup.boolean(),
            
            applies_to_locationTypes: yup.array(),
            applies_to_offerings: yup.array(),
            applies_to_class_ids: yup.array(),

            expires_at: yup.string()
        }),
        defaultValues: {
            id: toEdit?.id,

            code: toEdit?.code ?? "",

            discount_type: toEdit?.discount_type,
            discount_amount: toEdit?.discount_amount,

            redemption_type: toEdit?.redemption_type ?? "once_per_customer",
            max_redemptions: toEdit?.max_redemptions ?? 1,
            max_redemptions_user: toEdit?.max_redemptions_user ?? 1,

            is_enabled: toEdit?.is_enabled ?? true,
            expires_at: toEdit?.expires_at ? moment(toEdit.expires_at * 1000).format(DATE_FORMAT) : moment().add(5,'years').format(DATE_FORMAT),

            applies_to_all: toEdit?.applies_to_all ?? true,

            applies_to_locationTypes: toEdit?.applies_to_locationTypes ?? [],
            applies_to_offerings: toEdit?.applies_to_offerings ?? [],
            applies_to_class_ids: toEdit?.applies_to_class_ids ?? []
        }
    });
    useEffect(() => {
        register({ name: 'id'})
        // register({ name: 'isOneTimeOffer'})
        // register({ name: 'type'})
        // register({ name: 'expiresIn'})
        // register({ name: 'imageUrl'})
        // register({ name: 'active'})
        // How do you find instructors and how do you vet them?
    }, [register])

    const [isSaving, setIsSaving] = React.useState(false)
    const [saveError, setSaveError] = React.useState(null)

    console.log("Errors: ", errors)

    function hasWhiteSpace(s) {
        return /\s/g.test(s);
    }

    const onSubmit = (data) => {

        if (hasWhiteSpace(data.code)) {
            window.alert("Code must not contain spaces")
            return
        }

        data.code = data.code.replace(/\s/g, '')

        if (data.expires_at) {
            data.expires_at = moment(data.expires_at, DATE_FORMAT).endOf('day').unix()
        } else {
            data.expires_at = moment().add(50,'years').unix()
        }

        switch (data.redemption_type) {
        case "once_per_customer":
            data.max_redemptions = 9999999999
            data.max_redemptions_user = 1
            break
        case "limited_per_customer":
            data.max_redemptions = 9999999999
            data.max_redemptions_user = data.max_redemptions_user
            break
        case "limited":
            data.max_redemptions = data.max_redemptions
            data.max_redemptions_user = 9999999999
            break
        case "unlimited":
            data.max_redemptions = 9999999999
            data.max_redemptions_user = 9999999999
            break
        }

        const newData = {
            ...toEdit,
            ...data
        }

        // console.log("Submitting new coupon data: ", newData)
        // return

        setIsSaving(true)
        dispatch(saveCoupon(newData))
            .then(result => {
                if (result.success === false && result.message) {
                    throw result.message
                }
                setIsSaving(false)
                if (props.onHide) {
                    props.onHide()
                }
            })
            .catch(err => {
                setIsSaving(false)
                setSaveError(err)
                window.alert(err)
            })
        
    }
    
    const {discount_type, applies_to_all, redemption_type} = watch()

    // switch on type
    // fill viewModel placeholders with placeholders for each type
    // need to swap out "count" for "frequency" on the subscription side.
    return (
        <>
        <form onSubmit={handleSubmit(onSubmit)}>

            <FormGroup
                type="text"
                name="code"
                label="Code"
                sublabel="A code may only contain alphanumeric characters"
                placeholder={"Type a unique code"}
                register={register}
                error={errors.code}
                fullSize
            />

            <FormGroup
                select
                options={discountTypeOptions}
                type="text"
                name="discount_type"
                label="Type of discount"
                placeholder="Select one..."
                error={errors.discount_type}
                control={control}
                setValue={setValue}
                getValues={getValues}
                fullSize
            />

            <FormGroup
                type="number"
                name="discount_amount"
                label={discount_type === 'percentage' ? "Percent" : "Amount"}
                placeholder={discount_type === 'percentage' ? "Percentage discount" : "Discount amount"}
                register={register}
                error={errors.discount_amount}
                prepending={discount_type === 'percentage' ? ["%"] : [currencySymbol]}
                fullSize
            />

            <FormGroup
                select
                options={redemptionTypeOptions}
                type="text"
                name="redemption_type"
                label="How many times can this be used"
                placeholder="Select one..."
                error={errors.redemption_type}
                control={control}
                setValue={setValue}
                getValues={getValues}
                fullSize
            />

            <FormGroup
                className={redemption_type === 'limited' ? "" : "d-none"}
                type="number"
                name="max_redemptions"
                label="Number of uses"
                placeholder={"type amount"}
                register={register}
                error={errors.max_redemptions}
                fullSize
            />

            <FormGroup
                className={redemption_type === 'limited_per_customer' ? "" : "d-none"}
                type="number"
                name="max_redemptions_user"
                label="Number of uses"
                placeholder={"type amount"}
                register={register}
                error={errors.max_redemptions}
                fullSize
            />

            <FormGroup
                type="checkbox"
                name="applies_to_all"
                label="Applies to all products &amp; Services"
                placeholder="Check this box if you want this coupon to apply to anything that you sell"
                register={register}
                error={errors.expires}
                fullSize
            />

            <FormGroup
                className={applies_to_all ? "d-none" : ""}
                error={errors.locationTypes}
                fullSize
                select
                isMulti={true}
                options={locationTypeOptions}
                type="text"
                name="applies_to_locationTypes"
                label="Applies to locations"
                // sublabel=""
                placeholder="Select some or none"
                control={control}
                setValue={setValue}
                getValues={getValues}
            />

            <FormGroup
                className={applies_to_all ? "d-none" : ""}
                error={errors.applies_to_offerings}
                fullSize
                select
                isMulti={true}
                options={offeringOptions}
                type="text"
                name="applies_to_offerings"
                label="Includes packages &amp; subscriptions"
                // sublabel=""
                placeholder="Select some or none"
                control={control}
                setValue={setValue}
                getValues={getValues}
            />

            <FormGroup
                className={applies_to_all ? "d-none" : ""}
                error={errors.applies_to_class_ids}
                fullSize
                select
                isMulti={true}
                options={classOptions}
                type="text"
                name="applies_to_class_ids"
                label="Includes classes"
                // sublabel=""
                placeholder="Select some or none"
                control={control}
                setValue={setValue}
                getValues={getValues}
            />

            <FormDatePicker
                fullSize
                name="expires_at"
                label="Expiration Date"
                // sublabel=""
                placeholder="Select date"
                getValues={getValues}
                control={control}
                dateFormat={DATE_FORMAT}
                error={errors.expires_at}
            />

            <Modal.Footer>
                <Button type="submit" variant="primary" disabled={isSaving}>
                    <span>Save changes</span>
                    {isSaving && (
                        <Spinner
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden={true}
                        className="ml-2"
                      >
                        <span className="sr-only">Sending...</span>
                      </Spinner>

                    )}
                </Button>
            </Modal.Footer>
            {/* <div className="row">
                
            </div> */}

        </form>
        <DevTool control={control} />
        </>

    )
}

function CouponEditorModal(props) {

    const {show, onHide, toEdit} = props

    var viewModel = {
        title: toEdit ? "Edit Promo Code" : "Add Promo Code",
        description: (<span className="font-weight-bold">Please read &amp; watch <a target="_blank" href="http://help.sutrapro.com/en/articles/4663915-promo-codes-how-to">the FAQs</a> before adding a promo code.</span>)
    }

    return(
        <Modal
            centered
            // className={"modal-container custom-map-modal"}
            size="lg"
            // {...props}
            show={show}
            onHide={onHide}
            >
                <Modal.Header closeButton>
                    {viewModel.title}
                </Modal.Header>
                <Modal.Body>
                    {/* <p>A package is a group of classes that is typically discounted when a customer purchases multiple quantities. Packages do not expire and can be used on any live class.</p> */}
                    <p className="mb-5"><big>{viewModel.description}</big></p>
                    <CouponEditor
                    {...props}
                    toEdit={toEdit}
                    />
                </Modal.Body>
                
                
        </Modal>
    )
}

function NewCouponButton(props) {

    const location = useLocation()

    console.log("COUPON BUTTON LOCATION: ", location)

    const [newCouponOpen, setNewCouponOpen] = React.useState(false)
    // const [newSubOpen, setNewSubOpen] = React.useState(false)
    // const [newChallengeOpen, setNewChallengeOpen] = React.useState(false)
    // const [newOneTimeOfferOpen, setNewOneTimeOfferOpen] = React.useState(false)
    return (
        <div>
            <CouponEditorModal
            {...props}
            pack
            show={newCouponOpen}
            onHide={() => setNewCouponOpen(false)}
            />

            {!location?.hash.includes("gift") && (
                <Button onClick={() => {
                    setNewCouponOpen(true)
                    analytics.track("Clicked Add New Coupon")
                }} >
                    Add New&nbsp;+
                </Button>

            )}
        </div>
    );
}

export default NewCouponButton

function EditCouponButton(props) {

    const [open, setOpen] = React.useState(false)
    return (
        <div>

            <CouponEditorModal 
            {...props} // includes toEdit
            show={open}
            onHide={() => setOpen(false)}
            />
            <IconButton onClick={() => {
                if (!props.toEdit) {
                    window.alert("Unable to edit class")
                }
                setOpen(true)
            }}>
                <EditIcon/>    
            </IconButton>
        </div>
    );
}

export { EditCouponButton }

function DeleteCouponButton(props) {

    const [alert, setAlert] = React.useState(false)
    const { toDelete } = props

    const dispatch = useDispatch()

    function handleDelete() {

        console.log("Deleting coupon")
        dispatch(deleteCoupon(toDelete))
            .then(res => {
                setAlert(false)
            })
    }

    function confirmDelete() {

        setAlert(
            <SweetAlert
            showCancel
            confirmBtnText="Remove"
            confirmBtnBsStyle="danger"
            title="Are you sure you would like to remove?"
            onConfirm={() => handleDelete()}
            onCancel={() => setAlert(null)}
            focusCancelBtn
            >
             If you do, you can no longer sell this option.
            </SweetAlert>
        )
    }
 
    return (
        <div>
            {alert}
            <IconButton style={{color: "#ff4136"}} onClick={() => confirmDelete()}>
                <DeleteOutlineIcon/>    
            </IconButton>
        </div>
    );
}

export {DeleteCouponButton}